var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[(_vm.showIdle)?_c('IdleModal'):_vm._e(),_c('div',{attrs:{"id":"nav"}},[(_vm.authenticated)?_c('router-link',{attrs:{"to":"/login"}}):_vm._e()],1),_c('router-view',{on:{"authenticated":_vm.setAuthenticated}}),_c('app-modal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }